//---------------------------------------------------
//  Nom du fichier : Index.js 
//
//  Description: Component qui dirige l'utilisateur sur le site
//               contient le router qui crée les route
//               contient le webScoket pour avoir les live notifications
//
//  Auteur: Alek Del Balso et Vega Laliberté
//---------------------------------------------------

import React, { useState , useEffect} from 'react';
import ReactDOM from 'react-dom/client';  
import Acceuil from './Acceuil.js';
import Profil from './pageProfil.js'
import Rencontre from './Rencontre.js';
import Conversation from './Conversation.js';
import Publication from './Publication';  
import CreatePublication from './CreatePublication.js';  
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {callAPI} from './callAPI.js'
import AdminPage from './AdminPage.js';
import './_i18n.js'; // importe la config i18n

const App = () => {
    const [gradeType, setGradeType] = useState('american')
    const [loggedIn, setLoggedIn] = useState(false)
    const [publication, setPublication] = useState(null)
    const [markers, setMarkers] = useState([])
    const [creatingPublication, setcreatingPublication] = useState(false)
    const [destination, setDestination] = useState(null)
    const [imagePath, setImagePath] = useState(null)


    const [newMessages, setNewMessages] = useState([]);
    const [ws, setWs] = useState(null); // Store WebSocket instance

    document.addEventListener("visibilitychange", () => {
      if (ws && ws.readyState !== WebSocket.OPEN) {
        if (document.visibilityState === "visible") {
          connectWebSocket();
        }
      }
    });

    const connectWebSocket = () => {

        if(localStorage.getItem("user_id") == -1)return
        const socket = new WebSocket("wss://rockstoclimb.com/ws/");


        socket.onopen = () => {
            socket.send(JSON.stringify({ type: "connect", user_id: localStorage.getItem("user_id") }));

            const pingInterval = setInterval(() => {
              if (socket.readyState === WebSocket.OPEN) {
                  socket.send(JSON.stringify({ type: "ping" }));
              }
            }, 30000); // 30 seconds interval for pings
      
            // Clear the ping interval when the socket is closed
            socket.onclose = () => {
                clearInterval(pingInterval);
            };
        };

        socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if(data.fromAdmin)alert("Vous avez un nouveau Match!")
            setNewMessages((prev) => [...prev, data]); // Store messages
        };

        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        socket.onclose = () => {
        };

        setWs(socket);
    };

    const render_markers = () => {
  
      const form = new FormData()
      form.append('type', 'getMarkers')
  
      callAPI("read", form)
      .then((data) => {
          setMarkers(data["result"]); // Store the data in state
      })
      .catch((error) => {
          console.error("API call failed:", error);
      });
  
    }

    useEffect(() => {
      render_markers()
  
      if(localStorage.getItem("user_id") == null)
        localStorage.setItem("user_id", -1) //pour vérification
  
      const form = new FormData()
      callAPI("read", form)
      .then((data) => {
        setLoggedIn(data.user_id != -1)
        setGradeType(data.grade_type)
        setImagePath(data.imagePath)
        localStorage.setItem("user_id", data.user_id)
        localStorage.setItem("role", data.role)
        connectWebSocket()
      })
      .catch((error) => {
          console.error("API call failed:", error);
      });
  
    }, []);

    //https://reactrouter.com/6.30.0/start/tutorial
    return (
      <React.StrictMode>
        <Router>
          <Routes>
            <Route path="/:post_id?" element={
              <Acceuil  gradeType={gradeType}
                        setGradeType={setGradeType}
                        loggedIn={loggedIn}
                        setLoggedIn={setLoggedIn}
                        publication={publication}
                        setPublication={setPublication}
                        markers={markers}
                        creatingPublication={creatingPublication}
                        setcreatingPublication={setcreatingPublication}
                        destination={destination}
                        setDestination={setDestination}
                        render_markers={render_markers}
                        connectWebSocket={connectWebSocket}
                        newMessages={newMessages}
                        imagePath={imagePath}
                        setImagePath={setImagePath} />}/>

            <Route path="/profil/:user_id/:from?" element={
              <>
                <Profil set_grade_type={setGradeType} 
                        logged_in={loggedIn} 
                        setPublication={setPublication}
                        publication={publication}
                        setImagePath={setImagePath}/>
                
                {publication && 
                <Publication  setDestination={setDestination} 
                              post_id={publication} 
                              set_publication={setPublication}  
                              grade_type={gradeType} 
                              render_markers={render_markers}
                              setCreatingPublication={setcreatingPublication}
                              fromAcceuil={false}/>}
                
              {creatingPublication && 
              <CreatePublication  set_publication={setcreatingPublication} 
                                  info={creatingPublication} 
                                  grade_type={gradeType} 
                                  render_markers={render_markers}/>}
            </>
            }/>
            <Route path="/rencontre/:id?" element={<Rencontre gradeType={gradeType} ws={ws}/>}/>
            <Route path="/chat/:user_id" element={
              <Conversation ws={ws} 
                            newMessages={newMessages}
                            setNewMessages={setNewMessages}/>}/>
            <Route path="/Admin" element={
              <>
                <AdminPage setPublication={setPublication}/>
                {publication && 
                <Publication  setDestination={setDestination} 
                              post_id={publication} 
                              set_publication={setPublication}  
                              grade_type={gradeType} 
                              render_markers={render_markers}
                              setCreatingPublication={setcreatingPublication}/>}
              </>
            }/>
          </Routes>
        </Router>
      </React.StrictMode>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);  // Rendre l'application avec createRoot